import { createTheme } from "@mui/material/styles"
import { flow } from "fp-ts/es6/function"
import { pipe } from "fp-ts/es6/function"
import {
  __,
  assoc,
  complement,
  equals,
  identity,
  is,
  keys,
  mapObjIndexed,
  objOf,
  when,
} from "ramda/es"

import { List } from "@cirrus/fe-lib"

// TODO: Should be computed in compile time using macro.
const { palette: standardPalette } = createTheme()

export const UIKitLib = {
  standardPalette,
  standardPaletteKeys: keys(standardPalette),
}

export const { augmentColor } = UIKitLib.standardPalette

export const isCustomColor = List.notIncludes(__, UIKitLib.standardPaletteKeys)

export const isSecondary = equals("secondary")

export const normalized = when(
  is(Object),
  mapObjIndexed((value, key) =>
    pipe(
      value,
      when(complement(is(Object)), objOf("main")),
      isCustomColor(key) ? flow(objOf("color"), augmentColor, assoc("custom", true)) : identity,
    ),
  ),
)
